import { useMemo } from 'react'

import styled from 'styled-components'

import { ProjectSelector } from './ProjectSelector'

import { useNavigation } from '@/context/navigationContext'
import { useProject } from '@/context/projectContext'

import { QuerySupport } from 'types/navigation'

const Wrapper = styled.div`
  ${({ theme }) => theme.font.label02}
  margin: 10vh auto 20rem;
  max-width: 400px;
  background-color: ${({ theme }) => theme.colour.neutral.white};
  padding: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: 0 4px 28px 0 rgb(0 21 51 / 10%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
`

type Props = {
  forceRequired?: boolean
  children?: React.ReactNode
}

export const CorePageProjectRequired: React.FC<Props> = ({
  forceRequired,
  children,
}) => {
  const { currentNavItem } = useNavigation()
  const { isProjectSelected, hasProjects } = useProject()

  const required = useMemo(() => {
    return (
      forceRequired ??
      currentNavItem?.querySupport === QuerySupport.PROJECT_ONLY
    )
  }, [currentNavItem?.querySupport, forceRequired])

  if (required && !isProjectSelected && hasProjects) {
    return (
      <Wrapper>
        <span>To use this page, please select a project below</span>
        <ProjectSelector showBuilderProject={false} />
      </Wrapper>
    )
  }

  return <>{children}</>
}
